
import ReleasesApi from '@/api/releaseApi'
const api = new ReleasesApi()

export default {
  async getReleases(context, payload) {
    let releases = context.getters.getReleases
    if (!releases?.length || payload) {
      return await api.getReleases()
        .then(res => {
          context.commit('setReleases', res?.data?.releases) 
          return res?.data?.releases
        })
    } else {
      return releases
    }
  },
  async getAllFeatures(context, payload) {
    return await api.getAllFeatures( payload )
      .then(res => {
        return res?.data?.allFeatures
      })
  },
  async getFeatures(context, payload) {
    // let take = payload?.take,
    //   skip = payload?.skip,
    //   id = payload?.id
    return await api.getFeaturesById( payload )
      .then(res => {
        return res?.data?.features
      })
  },
  async getFeatureDetail(context) {
    return await api.getFeatureDetail()
      .then(res => {
        context.commit('setFeatureDetail', res?.data?.featureDetail) 
        return res?.data?.featureDetail
      })
  },
  async createFeature(context, payload) {
    if (payload) {
      return await api.createFeature( payload )
        .then(res => context.commit('setNewFeature', res?.data?.createFeature) )
    }
  },
  async createRelease(context, payload) {
    if (payload) {
      return await api.createRelease( payload )
        .then(res => {
          res = res?.data?.createRelease
          if (res) {
            context.commit('setNewRelease', res)
          }
          return res
        })
    }
  },
  async changeFeature(context, payload) {
    if (payload) {
      return await api.changeFeature( payload )
      // .then(res => context.commit('editFeature', res?.data?.changeFeature) )
    }
  },
  async changeRelease(context, payload) {
    if (payload) {
      return await api.changeRelease( payload )
        .then(res => {
          context.commit('editRelease', res?.data?.changeRelease)
        }
        )
    }
  },
  async deleteFeature(context, payload) {
    if (payload) {
      return await api.deleteFeature( payload.id || payload )
        .then(res => context.commit('deleteFeature', res?.data?.deleteFeature) )
    }
  },
  async deleteRelease(context, payload) {
    if (payload) {
      return await api.deleteRelease( payload.id || payload )
        .then(res => context.commit('deleteRelease', res?.data?.deleteRelease) )
    }
  },
  async changeReleaseNotificationOption(context, payload) {
    return await api.changeReleaseNotificationOption( payload )
  },
  async getReleasesSettings({state, commit}, payload) {
    if (state?.settings?.userAccess?.accessType != 'ALLOW') {
      return
    }

    let settings = state.releasesSettings
    if (!settings?.length || payload) {
      return await api.getReleasesSettings( payload )
        .then(res => {
          commit('setReleasesSettings', res) 
          return res
        })
    } else {
      return settings
    }
  },
  async setSignLastSeenRelease() {
    return await api.setSignLastSeenRelease(  )
  },
}